import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';
import { HttpService } from '../../http.service';
import { environment } from '../../../environments/environment';
import { DistributorContractArea } from '../../models/distributor-contract-area';

@Injectable()
export class DistributorContractAreasService extends BaseService
{
	private http: HttpService;
	private api: string;

	constructor(http: HttpService)
	{
		super();

		this.http = http;
		this.api = environment.api_url;
	}

	public getDistributorContractArea(id: number): Promise<DistributorContractArea>
	{
		return this.http
			.get(this.api + 'distributor-contract-areas/' + id)
			.toPromise()
			.then(response => response.json().data as DistributorContractArea)
			.catch(this.handleError);
	}

	public removeDistributorContractArea(id: number): Promise<null>
	{
		return this.http
			.delete(this.api + 'distributor-contract-areas/' + id)
			.toPromise()
			.then(response => null)
			.catch(this.handleError);
	}

	public updateDistributorContractArea(area: DistributorContractArea): Promise<DistributorContractArea>
	{
		return this.http
			.put(this.api + 'distributor-contract-areas/' + area.id, JSON.stringify(area))
			.toPromise()
			.then(response => response.json().data as DistributorContractArea)
			.catch(this.handleError);
	}

	public storeDistributorContractArea(area: DistributorContractArea): Promise<DistributorContractArea>
	{
		return this.http
			.post(this.api + 'distributor-contract-areas', JSON.stringify(area))
			.toPromise()
			.then(response => response.json().data as DistributorContractArea)
			.catch(this.handleError);
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/services/distributor-contract-areas.service.ts